<template>
  <div class="page-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="
              page-title-box
              d-sm-flex
              align-items-center
              justify-content-between
            ">
            <h4 class="mb-sm-0">Pencairan Tutup Akun</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item active">Daftar Pencairan Tutup Akun</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-header align-items-center d-flex">
              <h4 class="card-title mb-0 flex-grow-1">Daftar Investor Tutup Akun</h4>
              <router-link :to="{ name: 'close.account.create' }" class="btn btn-success waves-effect waves-light me-2">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Buat Form Tutup Akun
              </router-link>
              <button @click="showFilterClicked()" type="button" class="btn btn-primary waves-effect waves-light">
                <i class="bx bx-filter-alt font-size-16 align-middle me-2" :class="{
                  'rotate-down': show_filter,
                  'un-rotate': !show_filter,
                }"></i>
                Filter
              </button>
            </div>

            <div class="card-body">
              <div class="row mb-3" v-show="show_filter">
                <div class="col-md-5 mb-2">
                  <div class="input-group">
                    <label class="mt-2 me-2">Status</label>
                    <select class="form-select" v-model="filter.status">
                      <option value="">Semua</option>
                      <option value="pending">Menunggu</option>
                      <option value="process">Proses</option>
                      <option value="success">Selesai</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-5 mb-2">
                  <div class="input-group">
                    <label class="mt-2 me-2">Cari</label>
                    <input type="text" class="form-control" v-model="filter.search" placeholder="Nama atau NIK investor...">
                  </div>
                </div>
                <div class="col-md-2 mb-2">
                  <div class="float-end">
                    <button @click="resetFilter()" type="button" class="btn btn-danger me-2">
                      <i class="bx bx-x font-size-16 align-middle"></i>
                    </button>
                    <button @click="applyFilter()" type="button" class="btn btn-primary">
                      <i class="bx bx-check font-size-16 align-middle"></i>
                    </button>
                  </div>
                </div>
              </div>
              <DataTable :url="dataTableUrl" :columns="columnHeaders" :actions="actions" :reload="reloadDataTable" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { endpoint } from "../../host";
import DataTable from "../../components/datatable/DataTable.vue";
import moment from "moment";
import httpService from "../../services/http-service";
import globalService from "../../services/global-service";

export default {
  components: {
    DataTable,
  },

  created() {
    this.generateDataTableUrl();
  },

  data() {
    return {
      show_filter: false,
      reloadDataTable: false,
      dataTableUrl: null,
      filter: {
        status: '',
        search: '',
      },
      actions: [
        {
          icon: "bx bx-show",
          color: "btn-info",
          tooltip: "detail",
          onclick: (data) => {
            this.$router.push({
              name: "close.account.liquidation.detail",
              params: { id: data.id },
            });
          },
        },
      ],
      columnHeaders: [
        {
          text: "Tanggal Form",
          render: (data) => {
            return moment(data.created_at).format("DD MMMM YYYY HH:mm");
          },
        },
        {
          text: "Investor",
          render: (data) => {
            return data.name || '-';
          },
        },
        {
          text: "NIK",
          name: "nik",
        },
        {
          text: "Bank",
          render: (data) => {
            return `${data.bank_name} - ${data.bank_account_number}`;
          },
        },
        {
          text: "Status",
          render: (data) => {
            switch (data.status) {
              case "pending":
                return '<span class="badge bg-warning">Menunggu</span>';
              case "process":
                return '<span class="badge bg-info">Proses</span>';
              case "success":
                return '<span class="badge bg-success">Selesai</span>';
              default:
                return '<span class="badge bg-secondary">-</span>';
            }
          },
        },
      ],
    };
  },

  methods: {
    generateDataTableUrl() {
      this.dataTableUrl = httpService.generateEndpointQuery(endpoint['close.account.accounts'], this.filter);
    },

    showFilterClicked() {
      this.show_filter = !this.show_filter;
    },

    applyFilter() {
      this.generateDataTableUrl();
      this.reloadDataTable = !this.reloadDataTable;
    },

    resetFilter() {
      this.filter.status = '';
      this.filter.search = '';
      this.applyFilter();
    }
  },
};
</script>

<style>
.rotate-down {
  transform: rotate(180deg);
  transition: transform 0.3s;
}

.un-rotate {
  transform: rotate(0deg);
  transition: transform 0.3s;
}
</style>
